import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../../services/authentication.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {CommonComponent} from '../common/common.component';
import {NgForm} from '@angular/forms';
import {Location} from '@angular/common';
import {ToastaService} from 'ngx-toasta';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss']
})
export class PasswordRecoveryComponent extends CommonComponent implements OnInit {

  email: string;
  reCaptchaToken = '';

  constructor(
    private authenticationService: AuthenticationService,
    protected modalService: NgbModal,
    private location: Location,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
  }

  ngOnInit(): void {
    scroll(0, 0);



  }

  submit(form: NgForm) {
    this.loadingModalOn();

    this.recaptchaV3Service.execute('send_otp').pipe(
      switchMap(token => {
        this.reCaptchaToken = token;
        if (!this.reCaptchaToken) {
          throw new Error('Invalid reCAPTCHA token');
        }
        return this.authenticationService.passwordRecovery(this.email, this.reCaptchaToken);
      })
    ).subscribe({
      next: () => {
        this.loadingModalOff();
        this.msgSuccess(this.translate.instant('shared.password_recovery.message_success'));
        form.resetForm();
        this.email = null;
      },
      error: error => {
        this.msgError(error);
        this.loadingModalOff();
      }
    });
  }

  onBack() {
    this.location.back();
  }
}
